import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save2",
  "use": "save2-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"save2\"><path d=\"m7 11.061 4.03-4.03A.75.75 0 1 0 9.969 5.97l-2.22 2.22V0h-1.5v8.189L4.03 5.97a.75.75 0 1 0-1.061 1.061zM0 12.5V14h14v-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol